import { makeStyles } from '~/lib/bn-material-ui';

export default makeStyles(() => {
  const light = '#ededee';
  const dark = '#e5e5e6';
  return {
    box: {
      display: 'flex',
      justifyContent: 'center',
      background: 'inherit',
      height: '100%',
      width: '100%',
    },
    barContainer: {
      position: 'relative',
      width: '100%',
      height: '100%',
      overflow: 'hidden',
    },
    solid: {
      background: dark,
    },
    stripes: {
      background: `repeating-linear-gradient(-22.5deg, ${light}, ${light} 20px, ${dark} 20px, ${dark} 40px)`,
    },
    icon: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      margin: 'auto',
      fontSize: '40px',
      color: '#696a6c',
      opacity: 0.75,
      textAlign: 'center',
      maxWidth: '1em',
    },
  };
});
